module.exports = __webpack_public_path__ + "img/explicacao4.c27f4a40.png";